// extracted by mini-css-extract-plugin
module.exports = {"noNotifications":"styles_noNotifications__xVswe"};